
<b-modal
  id="support"
  size="lg"
  hideFooter
  hideHeader
  noFade
  hideBackdrop
  @keyup.esc="catchEscape"
  @show="showModal"
  @hide="closeModal"
  tabindex="1000"
>
  <div class="d-flex justify-content-between align-items-center">
    <h4>Slå upp förkortning</h4>

    <b-badge>Fokusera med CTRL+3</b-badge>
  </div>
  <b-form autocomplete="off" @submit.prevent="lookup">
    <b-form-input
      ref="lookupInput"
      v-model="lookupPhrase"
      :autofocus="!sharingList"
      placeholder
    />
      <small><em>Lägg  till <strong>*</strong> i slutet av frasen för "börjar med"-sökning<br /> Lägg till <strong>?</strong> för "innehåller frasen"-sökning<br />Sök i alla listor genom att avsluta med <strong>!</strong></em></small>
    <b-list-group>
      <b-list-group-item v-for="m in lookupResults" :key="'lookup_' + m.id">
        <span v-if="m.id >= 0">
          {{ m.match }}
        </span>
        <span v-else-if="m.id == -1">
          <b-badge variant="danger">{{ m.match }}</b-badge>
        </span>
        <span v-else>
          <b-badge variant="warning">{{ m.match }}</b-badge>
        </span>
      </b-list-group-item>
    </b-list-group>
  </b-form>

  <hr />

  <div class="d-flex justify-content-between align-items-center">
    <h4>Missade förkortningar</h4>
    <b-badge>Visa/dölj med CTRL+4</b-badge>
  </div>
  <div v-if="show.missedAbbs">
    <b-list-group
      style="overflow-y: auto; overflow-x: hidden; max-height: 40vh"
    >
      <b-list-group-item
        class="p-0 pl-2"
        v-for="abb in filteredMissedAbbs"
        :key="'missed_' + abb.word"
      >
        <b-row>
          <b-col cols="2">{{ abb.abb }}</b-col>
          <b-col cols="4"> {{ abb.word }}</b-col>
          <b-col cols="4"> {{ abb.counter }}</b-col>
          <b-col>
            <b-button
              size="sm"
              @click="dontRemindMissed(abb.abb)"
              variant="warning"
              >Påminn inte</b-button
            >
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
    <br />
    <b-button class="float-right" size="sm" @click="resetMissedAbbs()"
      >Nollställ</b-button
    >
  </div>
  <div v-else>
    <b-badge>...</b-badge>
  </div>
  <hr />

  <!--
      <div class="d-flex justify-content-between align-items-center">
          <h4>Ord som saknar förkortningar</h4>
          <b-badge>Visa/dölj med CTRL+5</b-badge>
      </div>
      <div v-if="show.suggestedAbbs">
          <b-list-group size="sm" style="max-height: 40vh; overflow-y: auto">
              <b-list-group-item
                  class="p-0 pl-2"
                  v-for="(s, index) in suggestions"
                  :key="'suggestion_' + index"
              >
                  {{ s }}
                  <span class="float-right">
                      <b-button size="sm" variant="primary" @click="addAbb(s)"
                          >Lägg till</b-button
                      >
                      <b-button size="sm" @click="ignoreSuggestion(s)"
                          >Ignorera</b-button
                      >
                  </span>
              </b-list-group-item>
          </b-list-group>
          <div class="float-right">
              <b-button
                  variant="danger"
                  size="sm"
                  @click="ignoreAllSuggestions"
                  >Ignorera alla</b-button
              >
          </div>
      </div>
      <div v-else>
          <b-badge>...</b-badge>
      </div>
      -->
  <b-form-datalist id="no-datalist"></b-form-datalist>
</b-modal>
